//@flow
class CustomStringUtil {
    static locationConfidenceToInputLabelKey(confidence) {
        switch (confidence) {
            case 'LOW':
                return 'verificationRequired';
            case 'MEDIUM':
                return 'inaccurateLocation';
            case 'HIGH':
                return 'moveMarker';
            default:
                return 'moveMarker';
        }
    }
}

export default CustomStringUtil;
